import {createAsyncThunk} from '@reduxjs/toolkit'
import AxiosClient from '../AxiosClient'
export const savePlatformPriceAsync = createAsyncThunk(
  'platform/savePlatformPriceAsync',
  async function (params: {payload?: any; platform_id?: number} | any, toolkit) {
    const url = `/platform-price-template`
    const payload = (params as any)?.payload ?? params
    return await AxiosClient('POST', url, payload, toolkit, {})
  }
)

export const getPlatformPriceAsync = createAsyncThunk(
  'platform/getPlatformPriceAsync',
  async function (
    params: {platform_id?: string; paginationdata: {page: number; limit: number,search: string}},
    toolkit
  ) {
    const url = `/platform-price-template?platform_id=${params.platform_id}`
    return await AxiosClient('GET', url, [], toolkit, params.paginationdata)
  }
)

export const updatePlatformPriceAsync = createAsyncThunk(
  'platform/updatePlatformPriceAsync',
  async function (params: {template_id?: number; platform_id?: number; payload: any}, toolkit) {
    const templateId = params.template_id ?? params.platform_id
    const url = `/platform-price-template/${templateId}`
    return await AxiosClient('PUT', url, params.payload, toolkit, [])
  }
)

export const deletPlatformPriceAsync = createAsyncThunk(
  'platform/deletPlatformPriceAsync',

  async function (params: {template_id?: number; platform_id?: string | number}, toolkit) {
    const templateId = params.template_id ?? params.platform_id
    const url = `/platform-price-template/${templateId}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

export const getPriceTemplateByIdAsync = createAsyncThunk(
  'platform/getPriceTemplateByIdAsync',
  async function (
    params: { templateId: number; platformId: number },
    toolkit
  ) {
    return await AxiosClient(
      'GET',
      `/platform-price-template/${params.templateId}`,
      [],
      toolkit,
      { platform_id: params.platformId, include_price_template: true }
    )
  }
)
